const FEATURE_HELP_URLS = {
  agent_bots: 'https://hub.kikin.me/hc/agent-bots',
  agents: 'https://hub.kikin.me/hc/agents',
  audit_logs: 'https://hub.kikin.me/hc/audit-logs',
  campaigns: 'https://hub.kikin.me/hc/campaigns',
  canned_responses: 'https://hub.kikin.me/hc/canned',
  channel_email: 'https://hub.kikin.me/hc/email',
  channel_facebook: 'https://hub.kikin.me/hc/fb',
  custom_attributes: 'https://hub.kikin.me/hc/custom-attributes',
  dashboard_apps: 'https://hub.kikin.me/hc/dashboard-apps',
  help_center: 'https://hub.kikin.me/hc/help-center',
  inboxes: 'https://hub.kikin.me/hc/inboxes',
  integrations: 'https://hub.kikin.me/hc/integrations',
  labels: 'https://hub.kikin.me/hc/labels',
  macros: 'https://hub.kikin.me/hc/macros',
  message_reply_to: 'https://hub.kikin.me/hc/reply-to',
  reports: 'https://hub.kikin.me/hc/reports',
  sla: 'https://hub.kikin.me/hc/sla',
  team_management: 'https://hub.kikin.me/hc/teams',
  webhook: 'https://hub.kikin.me/hc/webhooks',
  billing: 'https://hub.kikin.me/pricing',
  saml: 'https://hub.kikin.me/hc/saml',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
